import { useVerifyMedicationQuery } from "@/modules/patients/detail/medication/services/useVerifyMedicationQuery"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { useContextAppointment } from "@/modules/patients/hooks/useContextAppointment"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const useGetMedicationVerification = () => {
  const appointmentId = useAppointmentParam()
  const patientId = usePatientParam()
  const contextAppointment = useContextAppointment()
  const medicationVerificationData = useVerifyMedicationQuery(appointmentId ?? "", patientId, !appointmentId)

  const isVerified = medicationVerificationData?.isVerified

  const isFollowUpAppointment = contextAppointment?.appointmentType === "FOLLOW_UP"
  const medicationConfirmationNeeded = !isVerified && !isFollowUpAppointment

  return { medicationVerificationData, medicationConfirmationNeeded }
}

export { useGetMedicationVerification }
